<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10Z"
      fill="#4B4C52"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23 12C23 9.29517 18.0751 5 12 5C5.92487 5 1 9.33533 1 12C1 14.6647 5.92487 19 12 19C18.0751 19 23 14.7048 23 12ZM12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8Z"
      fill="#4B4C52"
    />
  </svg>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'IconShowPassword',
});
</script>
